import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { useAuthorization } from "@common/providers";
import useFlags from "@common/hooks/useFlags";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import Show from "./Show/Show";

interface Props {
  project_id: string;
}

const ScopeReviewMspa: React.FC<Props> = ({ project_id }) => {
  const authorized = useAuthorization();
  const { hasPrivilege, privilegesLoading, user } = usePrivilegeCheck();
  const { releaseServiceCorrelations } = useFlags();

  if (!authorized || privilegesLoading || !user) {
    return <ScopeStackSpinner />;
  }

  // LaunchDarklyProvider holds children until flags resolve, so undefined means
  // LaunchDarkly is unavailable. Anything but true is off, matching the nav link.
  if (releaseServiceCorrelations !== true) {
    return (
      <Navigate replace to={`/projects/${project_id}/project_approvals`} />
    );
  }

  // The API checks "manage or higher"; purge is the level above manage, and
  // the one /me reports for site admins.
  const canManage = hasPrivilege("projects.overview", ["manage", "purge"]);
  const canAddServices = hasPrivilege("projects.tasks", [
    "manage",
    "adjust_standards",
  ]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            projectId={project_id}
            canManage={canManage}
            canAddServices={canAddServices}
          />
        }
      />
    </Routes>
  );
};

export default ScopeReviewMspa;
